/**
 * Kartice u `VehiclePickerForm`, redoslijedom kojim se prikazuju.
 *
 * Obje na kraju daju isti JOM broj, ali poruke o pogrešci moraju govoriti o onome što korisnik
 * na toj kartici stvarno ispunjava.
 */
export const VEHICLE_SEARCH_TAB_INDEX = 0;
export const JOM_SEARCH_TAB_INDEX = 1;
